import React, { useState, useEffect } from 'react';
import { Button, Table, Space, Modal, Form, TimePicker, message, TreeSelect } from 'antd';
import { inventoryOrderTimeCategories, inventoryOrderTimeList, inventoryOrderTimeAdd, inventoryOrderTimeUpdate, inventoryOrderTimeDelete } from '../../api';
import moment from 'moment';
// import '../style.less';
import '../../style.less';
const layout = { labelCol: { span: 8, }, wrapperCol: { span: 12, }, };
const tailLayout = { wrapperCol: { offset: 8, span: 8, }, };
const formatTime = 'HH:mm';

// const base = { id: '', company_id: '', category_id: '', category_name: '', start: '', end: '', };
export default function OrderSetting() {
  // const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [type, setType] = useState('');
  const [currentId, setCurrentId] = useState('');
  const [form] = Form.useForm();
  const columns = [
    {
      title: '品类',
      dataIndex: 'category_name',
      key: 'category_name',
      width: 400,
      align: 'center'
    },
    {
      title: '允许下单时间',
      dataIndex: 'start',
      key: 'start',
      width: 400,
      align: 'center',
      render: (text, record) => <>{moment(text, formatTime).format(formatTime)}-{moment(record?.end, formatTime).format(formatTime)}</>
    },
    {
      title: '操作',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      // width: 400,
      render: (text, record) => {
        return <Space>
          <Button size='small' type='primary' onClick={() => updateItem(record)}>编辑</Button>
          <Button size='small' type='primary' onClick={() => deleteInventoryOrderTime(record)}>删除</Button>
        </Space>;
      }
    },
  ];
  useEffect(() => {
    getInventoryOrderTimeList();
    getInventoryOrderTimeCategories();
  }, []);

  const getInventoryOrderTimeList = async () => {
    const { data: { data, msg, code } } = await inventoryOrderTimeList();
    if (+code === 0) {
      const { list = [] } = data;
      setDataSource(list);
    } else {
      message.error(msg);
    }
  };
  const getInventoryOrderTimeCategories = async () => {
    const { data: { data, msg, code } } = await inventoryOrderTimeCategories();
    if (+code === 0) {
      const { list = [] } = data;
      setCategories(list);
    } else {
      message.error(msg);
    }
  };
  const addInventoryOrderTime = async (arg) => {
    const { data: { msg, code } } = await inventoryOrderTimeAdd(arg);
    if (+code === 0) {
      getInventoryOrderTimeList();
      closeModal();
      message.success(msg);
    } else {
      message.error(msg);
    }
  };
  const updateInventoryOrderTime = async (arg) => {
    const { data: { msg, code } } = await inventoryOrderTimeUpdate({ ...arg, id: currentId });
    if (+code === 0) {
      getInventoryOrderTimeList();
      closeModal();
      message.success(msg);
    } else {
      message.error(msg);
    }
  };
  const onFinish = (values) => {
    const { category_id = '', time = [] } = values;
    const [start, end] = time.map(item => moment(item).format(formatTime));
    const formateData = { category_id, start, end, category_name: categoryName.join('->') };
    const updateFun = {
      // 'add': (...arg) => addInventoryOrderTime(...arg),
      // 'update': (...arg) => updateInventoryOrderTime(...arg)
      'add': addInventoryOrderTime,
      'update': updateInventoryOrderTime
    };
    updateFun[type](formateData);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const addOrderTime = () => {
    setVisible(true);
    setType('add');
    form.setFieldsValue({ category_id: '', time: '' });
  };
  const closeModal = () => {
    setVisible(false);
  };
  const updateItem = (item) => {
    const { category_id, category_name, start, end, id } = item;
    setVisible(true);
    setCurrentId(id);
    setType('update');
    setCategoryName([category_name]);
    form.setFieldsValue({ category_id, time: [moment(start, formatTime), moment(end, formatTime)] });
  };
  const deleteInventoryOrderTime = async ({ id }) => {
    const { data: { msg, code } } = await inventoryOrderTimeDelete({ id });
    if (+code === 0) {
      getInventoryOrderTimeList();
      message.success(msg);
    } else {
      message.error(msg);
    }
  };
  const selectedTree = (selectedKeys, e) => {
    const getParentNode = (nodes, pid) => {
      for (let node of nodes) {
        if (node.id === pid) {
          return node;
        }
        if (node.children) {
          const parent = getParentNode(node.children, pid);
          if (parent) {
            return parent;
          }
        }
      }
      return null; // 没有找到父节点
    };
    var parent = null;
    var categoryName = [e.name];
    for (var i = e.level; i > 1; i--) {
      if (parent) {
        parent = getParentNode(categories, parent.pid);
      } else {
        parent = getParentNode(categories, e.pid);
      }
      categoryName.unshift(parent.name);
    }
    setCategoryName(categoryName);
    return;
  };
  return (
    <div className="proposal-order-list">
      <div className="plan-order-content">
        <div className='proposal-order-set'>
          <div style={{visibility:'hidden'}}>品类订货时间设置：</div>
          <Button type='primary' onClick={addOrderTime}>增加品类</Button>
        </div>
        <Table columns={columns} dataSource={dataSource} rowKey='id' pagination={false} locale={{ emptyText: '抱歉！暂无品类订货时间设置信息' }} />
        <Modal open={visible} title='品类订货设置' destroyOnClose footer={false} onCancel={closeModal}>
          <Form form={form} onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off" {...layout}>
            <Form.Item label="品类" name="category_id" rules={[{ required: true, message: '请选择品类!', },]}><TreeSelect
                style={{ width: '100%' }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={categories}
                placeholder='请选择品类'
                onSelect={selectedTree}
                filterTreeNode={(inputValue, treeNode) => treeNode.name.includes(inputValue)}
                showSearch
            ></TreeSelect></Form.Item>
            <Form.Item label="允许下单时间" name="time" rules={[{ required: true, message: '请选择允许下单时间!', },]}><TimePicker.RangePicker format={formatTime} /></Form.Item>
            <Form.Item {...tailLayout}><div className='proposal-order-set'><Button type="primary" htmlType="submit">确认</Button><Button htmlType="button" onClick={closeModal}>取消</Button></div></Form.Item>
          </Form>
        </Modal>
      </div>
    </div >
  );
}
